// The game on /playtest (docs/05-Tools/Level Designer.md, Playtest): a
// frame the level designer fills. It announces itself to the embedder,
// takes the first well-formed level it is sent and plays it with the local
// backend; no scene trips, the play screen alone over the night sky.
import { useEffect, useState } from 'react';
import { endPlaytest, startPlaytest, type PlaytestMessage } from '../../systems/play/playtest';
import { PlayScreen } from '../play/PlayScreen';
import './playtest.css';

export function PlaytestHost() {
  const [levelId, setLevelId] = useState<string | null>(null);
  const [problem, setProblem] = useState<string | null>(null);

  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      const data = e.data as PlaytestMessage | undefined;
      if (!data || data.type !== 'wits-playtest-level') return;
      const level = data.level as { id?: unknown };
      const error = startPlaytest(level);
      if (error) {
        setProblem(error);
        return;
      }
      setProblem(null);
      setLevelId(typeof level.id === 'string' ? level.id : null);
    };
    window.addEventListener('message', onMessage);
    window.parent?.postMessage({ type: 'wits-playtest-ready' } satisfies PlaytestMessage, '*');
    return () => {
      window.removeEventListener('message', onMessage);
      endPlaytest();
    };
  }, []);

  return (
    <div className="playtest-host">
      {problem && <div className="playtest-problem">The level could not be read: {problem}</div>}
      {!levelId && !problem && <div className="playtest-waiting quiet">Waiting for a level from the designer…</div>}
      {levelId && <PlayScreen key={levelId} route={{ levelId }} arrived={true} />}
    </div>
  );
}
